import React from 'react';
import { confirmable, createConfirmation } from 'react-confirm';
import BasicButton from 'components/BasicButton';
import Dialog from 'scenes/Dialog';
import Popup from 'components/Popup';
import UxHelpers from 'helpers/ux-helpers.js';

import './styles.css';

const DeleteAccountRequestFirstStepDialog = (props) => {
  const { show, proceed, dismiss } = props;

  const onSuccess = (data) => {
    proceed(data);
    UxHelpers.overflowLock('unlock');
  };

  const body = (
    <Dialog dialogStyles={{ width: 700, marginBottom: '-20px' }} dialogCssClass={'delete-account-dialog'}>
      <div className="delete-account-request-second-step-dialog">
        <div className="delete-account-request-second-step-dialog--message">
          You can leave the platform by hiding or permanently deleting your account. Which fits you best?
        </div>
        <div className="delete-account-request-second-step-dialog--row">
          <div className="delete-account-request-second-step-dialog--column-left">
            <div className="delete-account-request-second-step-dialog--button-wrapper">
              <BasicButton
                controlFunc={() => {
                  onSuccess(1);
                }}
                btnFontWeight={500}
                btnArrow={false}
                btnHeight={80}
                btnWidth={200}
                btnTextColor="#27282d"
                btnTextAlign="center"
                btnText="Hide my account"
              />
            </div>
          </div>
          <div className="delete-account-request-second-step-dialog--column-right">
            <div className="delete-account-request-second-step-dialog--desc">
              <ul>
                <li>Profile is retained but is hidden from the platform</li>
                <li>If you choose to login in after, you can still access the site materials and apply to
                  opportunities
                </li>
                <li>Next screen will prompt you to unsubscribe from all emails</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="delete-account-request-second-step-dialog--row">
          <div className="delete-account-request-second-step-dialog--column-left">
            <div className="delete-account-request-second-step-dialog--button-wrapper">
              <BasicButton
                controlFunc={() => {
                  onSuccess(2);
                }}
                btnFontWeight={500}
                btnHeight={80}
                btnWidth={230}
                btnArrow={false}
                btnTextColor="#27282d"
                btnTextAlign="center"
                btnText="Permanently delete my account"
              />
            </div>
          </div>
          <div className="delete-account-request-second-step-dialog--column-right">
            <div className="delete-account-request-second-step-dialog--desc">
              <ul>
                <li>Your account will be deleted, and profile will be removed</li>
                <li>To regain access, you’ll need to create a new account</li>
                <li>You will no longer have access to the job board, prep materials, or reviews on GoBuyside</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  );

  return (
    show && (
      <Popup
        actions={{ dismiss }}
        bodyRender={body}
      />
    )
  );
};

export default createConfirmation(confirmable(DeleteAccountRequestFirstStepDialog));
